import React from 'react';
import Carousel from 'react-material-ui-carousel'
import Image from './img/Engaging-an-AC-Compressor-Clutch.jpg'
import {makeStyles} from '@material-ui/core/styles';
import Para1 from './img/slider/image.jpg';
import Para2 from './img/product2.jpg';
import AOS from 'aos';
import "aos/dist/aos.css";
import Typography from '@material-ui/core/Typography';
import { colors } from './sharedStyles';
import Images from './img';

const useStyles = makeStyles((theme) => ({
  heroSection: {
    position: 'relative',
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    overflow: 'hidden',
  },
  heroOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: `rgba(44, 62, 80, 0)`,
    zIndex: 1,
  },
  heroContent: {
    position: 'relative',
    zIndex: 2,
    textAlign: 'center',
    color: colors.white,
    maxWidth: 800,
    padding: '0 20px',
  },
  heroTitle: {
    fontSize: '3.5rem',
    fontWeight: 700,
    marginBottom: '1rem',
    textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
    [theme.breakpoints.down('md')]: {
      fontSize: '2.5rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '2rem',
    },
  },
  container: {
    maxWidth: 1200,
    margin: '0 auto',
    padding: '0 20px',
  },
  sectionTitle: {
    fontSize: '2.5rem',
    fontWeight: 700,
    textAlign: 'center',
    marginBottom: '3rem',
    color: colors.dark,
    position: 'relative',
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: '-10px',
      left: '50%',
      transform: 'translateX(-50%)',
      width: '60px',
      height: '4px',
      background: `linear-gradient(45deg, ${colors.primary}, ${colors.secondary})`,
      borderRadius: 2,
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '2rem',
    },
  },
  lightSection: {
    background: `linear-gradient(135deg, ${colors.light} 0%, #D1E9FB 100%)`,
    padding: '80px 0',
  },
  galleryDescription: {
    textAlign: 'center',
    maxWidth: 800,
    margin: '0 auto 3rem',
    color: colors.text,
    fontSize: '1.1rem',
    lineHeight: 1.8,
  },
  galleryContainer: {
    background: colors.white,
    borderRadius: 16,
    padding: '40px',
    boxShadow: '0 8px 32px rgba(97, 218, 251, 0.15)',
    border: '1px solid rgba(97, 218, 251, 0.1)',
  },
}));

function Example(){
  AOS.init({
    duration: 800,
    once: true,
    offset: 100
  });
  
  const classes = useStyles();
  
  var items = [
    {
      name: <h1 style={{color: colors.white, fontSize: "3.5rem", marginTop: 0, fontWeight: 700}} data-aos={"fade-up"}>
        <span style={{ padding: 12, backgroundColor: `rgba(44, 62, 80, 0.5)`, borderRadius: 8, textShadow: '2px 2px 4px rgba(0,0,0,0.5)', border: `2px solid rgba(97, 218, 251, 0.3)`}}>
          Our Gallery
        </span>
      </h1>,
      image: Para1,
      description: ""
    }
  ];

  return (
    <div>
      {/* Hero Section */}
      <Carousel swipe={true} indicators={false} touch={true} animation={"slide"} interval={5000}>
        {items.map((item, i) => <Item key={i} item={item} />)}
      </Carousel>

      {/* Gallery Section */}
      <section className={classes.lightSection}>
        <div className={classes.container}>
          <Typography variant="h2" className={classes.sectionTitle} data-aos="fade-up">
            Mission Moments
          </Typography>
          
          <Typography variant="body1" className={classes.galleryDescription} data-aos="fade-up">
            Explore our mission work through these powerful images that capture the impact of our outreach programs, 
            evangelism efforts, and community service initiatives around the world. Each photo tells a story of hope, 
            transformation, and the love of Christ being shared with communities in need.
          </Typography>

          <div className={classes.galleryContainer} data-aos="fade-up">
            <Images />
          </div>
        </div>
      </section>
    </div>
  );
}

function Item(props) {
  const classes = useStyles();
  return (
    <div 
      className={classes.heroSection} 
      style={{
        backgroundImage: `linear-gradient(rgba(44, 62, 80, 0.7), rgba(44, 62, 80, 0.7)), url(${props.item.image})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <div className={classes.heroOverlay}></div>
      <div className={classes.heroContent}>
        {props.item.name}
        <Typography variant="h4" style={{color: colors.white, fontSize: '1.2rem', marginTop: '1rem'}} data-aos="fade-up">
          {props.item.description}
        </Typography>
      </div>
    </div>
  );
}

export default Example;


